/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The “d” stands for die and the number is its sides — d6 is a six-sided die, d20 a twenty-sided one, and so on.`)
};

const es_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La «d» significa dado y el número son sus caras — d6 es un dado de seis caras, d20 uno de veinte caras, y así sucesivamente.`)
};

const de_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das „d“ steht für Würfel (die) und die Zahl gibt die Seitenanzahl an — d6 ist ein sechsseitiger Würfel, d20 ein zwanzigseitiger und so weiter.`)
};

const nl_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 'd' staat voor dobbelsteen (die) en het getal is het aantal zijden — d6 is een zeszijdige dobbelsteen, d20 een twintigzijdige, enzovoort.`)
};

const fr_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le « d » signifie dé et le nombre correspond à ses faces — d6 est un dé à six faces, d20 un dé à vingt faces, et ainsi de suite.`)
};

const it_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La "d" sta per dado e il numero è il numero delle sue facce — d6 è un dado a sei facce, d20 uno a venti facce, e così via.`)
};

const pt_br2_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O “d” representa dado e o número é a quantidade de lados — d6 é um dado de seis lados, d20 um de vinte lados, e assim por diante.`)
};

const pt_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O “d” representa dado e o número é o número de faces — d6 é um dado de seis faces, d20 um de vinte, e assim por diante.`)
};

const ja_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「d」はダイス(die)の略で、数字は面数を表します — d6は6面サイコロ、d20は20面サイコロという具合です。`)
};

const zh_dice_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“d”代表骰子（die），后面的数字是它的面数——d6 是六面骰，d20 是二十面骰，以此类推。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_faq_a3", locale)
	if (locale === "en") return en_dice_faq_a3(inputs)
	if (locale === "es") return es_dice_faq_a3(inputs)
	if (locale === "de") return de_dice_faq_a3(inputs)
	if (locale === "nl") return nl_dice_faq_a3(inputs)
	if (locale === "fr") return fr_dice_faq_a3(inputs)
	if (locale === "it") return it_dice_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_dice_faq_a3(inputs)
	if (locale === "pt") return pt_dice_faq_a3(inputs)
	if (locale === "ja") return ja_dice_faq_a3(inputs)
	return zh_dice_faq_a3(inputs)
};